import React from 'react';
import { SvgIcon } from './utils/SvgIcon.js';
import type { SvgIconT } from './utils/react-desc-prop-types.js';

const CheckmarkCircleFillSmall = (props: SvgIconT.Props) => (
  <SvgIcon width={24} height={24} {...props} viewBox="0 0 24 24">
    <path d="M 12 6.5 A 5.5 5.5 0 1 1 12 17.5 A 5.5 5.5 0 1 1 12 6.5 Z M 14.657 9.664 L 11.12 13.2 L 9.706 11.786 L 8.999 12.493 L 11.12 14.614 L 15.363 10.371 L 14.656 9.664 Z"></path>
  </SvgIcon>
);

export default CheckmarkCircleFillSmall;
